import glassesIcon from '../assets/hp_icons/glasses.png';
import hatIcon from '../assets/hp_icons/hat.png';
import scrollIcon from '../assets/hp_icons/scroll.png';
import owlIcon from '../assets/hp_icons/owl.png';
import letterIcon from '../assets/hp_icons/letter.png';
import timeturnerIcon from '../assets/hp_icons/timeturner.png';
import wandIcon from '../assets/hp_icons/wand.png';
import beerIcon from '../assets/hp_icons/beer.png';
import bookIcon from '../assets/hp_icons/book.png';
import goldenSnitchIcon from '../assets/hp_icons/golden-snitch.png';
import cauldronIcon from '../assets/hp_icons/cauldron.png';
import scarfIcon from '../assets/hp_icons/scarf.png';
import hogwartsCrestIcon from '../assets/hp_icons/hogwarts-crest.png';
import potionIcon from '../assets/hp_icons/potion.png';

// Map icon names to their image paths
export const iconImages: Record<string, string> = {
  'glasses': glassesIcon,
  'hat': hatIcon,
  'scroll': scrollIcon,
  'owl': owlIcon,
  'letter': letterIcon,
  'timeturner': timeturnerIcon,
  'wand': wandIcon,
  'beer': beerIcon,
  'book': bookIcon,
  'golden-snitch': goldenSnitchIcon,
  'cauldron': cauldronIcon,
  'scarf': scarfIcon,
  'hogwarts-crest': hogwartsCrestIcon,
  'potion': potionIcon
}; 